import websitePage, { FOOTER_TYPE_NO_NAVIGATION } from '../../hoc/websitePage/websitePage';
import MGMHomePage from '../../screens/MGM/MGM';
import { domain } from '../../utils/seo';

const images = [
  {
    url: `${domain}/images/seo/mgm/open-graph-mgm-large.jpg`,
    width: 1200,
    height: 630,
  },
  {
    url: `${domain}/images/seo/mgm/open-graph-mgm.jpg`,
    width: 900,
    height: 900,
  },
];

export default websitePage(MGMHomePage, {
  routeKey: 'MGM',
  footer: FOOTER_TYPE_NO_NAVIGATION,
  customSEOImages: images,
  btnVisibleScrolling: true,
  buttonLabel: 'HOME.HERO.BUTTON_LABEL.MULTIPRODUCT',
});

